import { Tooltip as MUITooltip, type TooltipProps } from "@mui/material";
import { type FC } from "react";

export const Tooltip: FC<TooltipProps> = ({
  children,
  placement = "right",
  title,
  ...props
}) => {
  return (
    <MUITooltip
      {...props}
      componentsProps={{
        tooltip: {
          sx: {
            "& .MuiTooltip-arrow": {
              color: "white",
            },
            backgroundColor: "#fff",
            color: "#414141",
            border: "1px solid",
            borderColor: "background.paper",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            fontSize: "14px",
            fontWeight: 400,
            padding: "12px 16px",
            borderRadius: "8px",
            whiteSpace: "pre-wrap",
          },
        },
      }}
      placement={placement}
      title={title}
    >
      {children}
    </MUITooltip>
  );
};
